// ink-component
import React, { ReactNode, MouseEvent } from 'react';
import { Moment } from 'moment';

import CoreCalendar, { DateMask } from '../../../_common/CoreDatePicker/Calendar/Calendar';
import {
  CustomDate,
  CalendarShortcutsProps,
} from '../../../_common/CoreDatePicker/Calendar/CalendarShortcuts/CalendarShortcuts';

/* Prop interface naming exception */
export interface NewCalendarProps {
  value: string;
  onChange: (e: MouseEvent<HTMLButtonElement>, value: string) => void;
  closeCalendar: () => void;
  dateMask: DateMask;
  selectedDate: CustomDate;
  setSelectedDate: (arg1: string) => void;
  onDateClick: (e: any, day: Moment) => void;
  /** For a given date passed in as an argument, return `false` to disable it. */
  disableDates?: (date: string) => boolean;
  /** RenderProp for Shortcuts. Should return a NewDatePicker.Shortcuts.
   * You can spread the props from the callback into the Component. */
  shortcuts?: (shortcutsProps: CalendarShortcutsProps) => ReactNode;
  'data-testid'?: string | number;
  'aria-label'?: string;
}
/**
 * @purpose Allows users to choose a date
 * @categories form
 * @group NewDatePicker
 */
function Calendar(props: NewCalendarProps) {
  // @ts-ignore
  const { className, style, ...otherProps } = props;

  return <CoreCalendar {...otherProps} />;
}

Calendar.defaultProps = {
  disableDates: undefined,
  shortcuts: undefined,
};

Calendar.displayName = 'NewDatePicker.Calendar';

export default Calendar;
